import styled from 'styled-components';

import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { ActionMenu } from 'ui/actionMenu';
import {
  ActionMenuOption,
  AllowedActionMenuElements,
  MENU_ALIGNMENTS,
  MENU_DIRECTIONS,
} from 'ui/actionMenu/types';
import { ChevronDown } from 'ui/icons';

import { useQueryParamContext } from '../../context/QueryParamContext';
import { displayContent } from '../content';
import { TemplateEditViews } from '../types';

const ChevronUp = styled(ChevronDown)`
  transform: rotate(180deg);
`;

export const ViewSwitchMenu = () => {
  const { setView } = useQueryParamContext();

  const setViewOptions: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: displayContent.btnDetails,
      id: 'btn-view-settings',
      onClick: () => setView(TemplateEditViews.settings),
    },
    {
      as: AllowedActionMenuElements.Button,
      content: displayContent.btnContent,
      id: 'btn-view-content',
      onClick: () => setView(TemplateEditViews.content),
    },
  ];

  return (
    <ActionMenu
      align={MENU_ALIGNMENTS.RIGHT}
      direction={MENU_DIRECTIONS.TOP}
      options={setViewOptions}
    >
      <Button
        data-test={'set-view-action-menu'}
        size={BUTTON_SIZES.LARGE}
        variant={BUTTON_VARIANTS.SECONDARY}
      >
        <span>{displayContent.btnView}</span>
        <ChevronUp height={16} width={16} />
      </Button>
    </ActionMenu>
  );
};

export default ViewSwitchMenu;
